import React from 'react';
import { NewLandingPage } from './pages/NewLandingPage';
export function App() {
  return <NewLandingPage data-id="element-0" />;
}